import script from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"

import "./ProxyContent.vue?vue&type=style&index=0&id=29c84b40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c84b40"]])

export default __exports__